<template>
  <div class="statement-details">
    <extend-modal
      classes="justify-content-center w-100"
      v-if="showModal"
      :loading="loading"
      :toggle="() => $emit('toggleModal')"
      :use-red-header-close="true"
    >
      <div class="modal-body px-5">
        <div class="details__card__container">
          <div class="details__card__header pl-0 pr-0">
            <div class="row align-items-center m-0">
              <div class="col-auto p-0">
                <h1 class="title">Details</h1>
              </div>
            </div>
          </div>
          <div class="details__card__item border-none pt-2">
            <div class="details__card__item__left">
              <div class="details__card__item__label">Amount</div>
              <div class="details__card__item__value">
                &#8358;&nbsp;{{ details.amount || 0 }}
              </div>
            </div>
            <div class="details__card__item__right">
              <div class="details__card__item__label">Bank Name</div>
              <div class="details__card__item__value">
                {{ details.bank_name || "N/A" }}
              </div>
            </div>
          </div>

          <div class="details__card__item">
            <div class="details__card__item__left">
              <div class="details__card__item__label">Value Date</div>
              <div class="details__card__item__value uppercase">
                {{ details.value_date || "N/A" | date }} <br />
              </div>
            </div>

            <div class="details__card__item__right">
              <div class="details__card__item__label">Unique Identifier</div>
              <div class="details__card__item__value">
                {{ details.unique_identifier || "N/A" }}
              </div>
            </div>
          </div>

          <div class="details__card__item">
            <div class="details__card__item__left">
              <div class="details__card__item__label">Transaction Date</div>
              <div class="details__card__item__value">
                {{ details.transaction_date || "N/A" | date }}
              </div>
            </div>

            <div class="details__card__item__right">
              <div class="details__card__item__label">Data Source</div>
              <div class="details__card__item__value">
                {{ details.data_source || "N/A" }}
              </div>
            </div>
          </div>
          <div class="details__card__item">
            <div class="details__card__item__left">
              <div class="details__card__item__label">Running Balance</div>
              <div class="details__card__item__value">
                {{ details.running_balance || "N/A" }}
              </div>
            </div>

            <div class="details__card__item__right">
              <div class="details__card__item__label">
                Transaction Reference
              </div>
              <div class="details__card__item__value">
                {{ details.transaction_reference || "N/A" }}
              </div>
            </div>
          </div>

          <div class="details__card__item">
            <div class="details__card__item__left">
              <div class="details__card__item__label">Narration</div>
              <div class="details__card__item__value">
                {{ details.narration || "N/A" }}
              </div>
            </div>

            <div class="details__card__item__right">
              <div class="details__card__item__label">
                Reconciliation Status
              </div>
              <div class="details__card__item__value">
                {{ details.reconciliation_status || "N/A" }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </extend-modal>
  </div>
</template>

<script>
import ExtendModal from "../../../components/ExtendModal";
export default {
  name: "StatementDetails",
  components: { ExtendModal },
  metaInfo: {
    title: "Details",
  },
  props: {
    showModal: false,
    loading: false,
    details: {
      default: {},
    },
  },
};
</script>

<style lang="scss">
.statement-details {
  .modal-content {
    min-width: 37.5% !important;
    max-width: 600px;
    border-radius: 4px !important;

    .w-100 {
      width: 100%;
    }
  }
  .modal-body {
    width: 100%;

    .border-none {
      border: none;
    }

    .details__card__container {
      border: none;
      box-shadow: none;

      .title {
        font-weight: 300;
      }

      .details__card__item {
        padding-left: 0;
        padding-right: 0;
        &__left {
          text-align: left;
        }
      }
    }
  }
}
</style>
